import * as XLSX from 'xlsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TExportFieldConfig = string | { field?: string; callback?: (value: any) => any };

const getNestedValue = (item: Record<string, unknown>, path: string): unknown => path.split('.').reduce<unknown>((value, key) => (
  value && typeof value === 'object' ? (value as Record<string, unknown>)[key] : undefined
), item);

const resolveFieldValue = (item: Record<string, unknown>, config: TExportFieldConfig): unknown => {
  const field = typeof config === 'string' ? config : config.field;
  const value = field ? getNestedValue(item, field) : item;
  const callback = typeof config === 'object' ? config.callback : undefined;
  return callback ? callback(value) : value;
};

const buildRows = (
  data: Record<string, unknown>[],
  fields?: Record<string, TExportFieldConfig> | null,
): Record<string, unknown>[] => {
  if (!fields) return data;

  return data.map((item) => Object.entries(fields).reduce((row, [header, config]) => ({
    ...row,
    [header]: resolveFieldValue(item, config),
  }), {} as Record<string, unknown>));
};

/**
 * Exports `data` as a CSV or XLS file, downloaded via the browser.
 * `fields` maps each output column header to either a (possibly dot-nested) source
 * property path, or a `{ field?, callback? }` config for computed values.
 */
export const exportToExcel = (
  data: Record<string, unknown>[],
  fields: Record<string, TExportFieldConfig> | null | undefined,
  filename: string,
  type: 'csv' | 'xls' = 'csv',
): void => {
  if (!data || !data.length) return;

  const rows = buildRows(data, fields);
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  XLSX.writeFile(workbook, filename, { bookType: type });
};
